<nb-card style="height: 100%;">
    <nb-card-header>
        Tasks Completed By Day
    </nb-card-header>
    <nb-card-body [nbSpinner]="isLoading">
        <div *ngIf="!isTasksNull" class="chart-container"  style="display: block">
            <canvas id="tasksCompletedLineGraph" height="300" toolTip="true"></canvas>
        </div>
        <div class="row" *ngIf="isTasksNull">
            <div class="col-lg-12 col-12" style="text-align: center;">
                <h5 style="padding-top: 25px;">No current tasks</h5>
            </div>
        </div>
    </nb-card-body>
</nb-card>